import ContentOverlay from "../components/content_overlay";
import {Link} from "react-router-dom";
import "./abstract.css";

function E_linksPage(){
    return (
        <ContentOverlay
        heading={ <h3 style={{textAlign:"center"}}>E-Links</h3>}
        text_content={<div><p class="western" ><u><strong>International Level</strong></u></p>
            <ol>
            <li>
            <p ><a name="_GoBack"></a> <strong>NASA Goddard Institute for Space Studies (GISS)</strong></p>
            <p ><u><a href="https://www.giss.nasa.gov/"><strong>https://www.giss.nasa.gov/</strong></a></u></p></li></ol>
            <p></p>
            <ol start="2">
            <li>
            <p ><strong>Berkeley Earth</strong></p>
            <p ><u><a href="https://berkeleyearth.org/"><strong>https://berkeleyearth.org/</strong></a></u></p></li></ol>
            <p class="western"></p>
            <ol start="3">
            <li>
            <p ><strong>ESA Climate Office</strong></p>
            <p ><u><a href="https://climate.esa.int/"><strong>https://climate.esa.int/</strong></a></u></p></li></ol>
            <p class="western"></p>
            <ol start="4">
            <li>
            <p ><strong>National Oceanic and Atmospheric Administration </strong></p>
            <p ><u><a href="https://www.noaa.gov/"><strong>https://www.noaa.gov/</strong></a></u></p></li></ol>
            <p class="western"></p>
            <ol start="5">
            <li>
            <p ><strong>Climate Change Knowledge Portal</strong></p>
            <p ><u><a href="https://climateknowledgeportal.worldbank.org/"><strong>https://climateknowledgeportal.worldbank.org/</strong></a></u></p></li></ol>
            <p class="western"></p>
            <ol start="6">
            <li>
            <p ><strong>Earth Data</strong></p>
            <p ><u><a href="https://www.earthdata.nasa.gov/"><strong>https://www.earthdata.nasa.gov/</strong></a></u></p></li></ol>
            <p class="western"></p>
            <ol start="7">
            <li>
            <p ><strong>USGS</strong></p>
            <p ><u><a href="https://www.usgs.gov/"><strong>https://www.usgs.gov/</strong></a></u></p></li></ol>
            <p class="western"></p>
            <ol start="8">
            <li>
            <p ><strong>Copernicus </strong></p>
            <p ><u><a href="https://land.copernicus.eu/"><strong>https://land.copernicus.eu/</strong></a></u></p></li></ol>
            <p class="western"></p>
            <ol start="9">
            <li>
            <p ><strong>ICPAC</strong></p>
            <p ><u><a href="https://www.icpac.net/"><strong>https://www.icpac.net/</strong></a></u></p></li></ol>
            <p></p>
            <p></p>
            <p class="western" ></p>
            <p class="western" ><u><strong>National Level</strong></u></p>
            <ol>
            <li>
            <p ><strong>Western Ghats Spatial Decision Support System</strong></p>
            <p ><u><a href="https://wgbis.ces.iisc.ac.in/sdss/wgsdss/v2/"><strong>https://wgbis.ces.iisc.ac.in/sdss/wgsdss/v2/</strong></a></u></p></li></ol>
            <p class="western"></p>
            <ol start="2">
            <li>
            <p ><strong>Climate Change Knowledge Portal</strong></p>
            <p ><u><a href="https://climateknowledgeportal.worldbank.org/"><strong>https://climateknowledgeportal.worldbank.org/</strong></a></u></p></li></ol>
            <p class="western" ></p>
            <ol start="3">
            <li>
            <p  ><strong>India Meteorological Department (IMD)</strong></p>
            <p  ><u><a href="https://mausam.imd.gov.in/"><strong>https://mausam.imd.gov.in/</strong></a></u></p></li></ol>
            <p class="western" ></p>
            <ol start="4">
            <li>
            <p  ><strong>Indiastat</strong></p>
            <p  ><u><a href="https://www.indiastat.com/data/meteorological-data/temperature/data-year/all-years"><strong>https://www.indiastat.com/data/meteorological-data/temperature/data-year/all-years</strong></a></u></p></li></ol>
            <p class="western" ></p>
            <ol start="5">
            <li>
            <p  ><strong>Open Government Data (OGD) platform India</strong></p>
            <p  ><u><a href="https://www.data.gov.in/"><strong>https://www.data.gov.in/</strong></a></u></p></li></ol>
            <p ></p>
            <p ></p>
            <ol start="6">
            <li>
            <p ><strong>Open city urban data portal</strong></p>
            <p  ><u><a href="https://data.opencity.in/"><strong>https://data.opencity.in/</strong></a></u></p></li></ol>
            <p class="western" ></p>
            <ol start="7">
            <li>
            <p  ><strong>IARI Meteorological Database System</strong></p>
            <p  ><u><a href="https://www.iari.res.in/bms/daily-weather/"><strong>https://www.iari.res.in/bms/daily-weather/</strong></a></u></p></li></ol>
            <p class="western" ></p>
            <ol start="8">
            <li>
            <p ><strong>India Meteorological Department (IMD)</strong></p>
            <p  ><u><a href="https://www.imdpune.gov.in/"><strong>https://www.imdpune.gov.in/</strong></a></u></p></li></ol>
            <p class="western"></p>
            <ol start="9">
            <li>
            <p ><strong>Ministry of Earth Sciences (MoES)</strong></p>
            <p ><u><a href="https://moes.gov.in/"><strong>https://moes.gov.in/</strong></a></u></p></li></ol>
            <p></p>
            <ol start="10">
            <li>
            <p ><strong>Meteorological &amp; Oceanographic Satellite data Archival Centre</strong></p>
            <p ><u><a href="https://www.mosdac.gov.in/"><strong>https://www.mosdac.gov.in/</strong></a></u></p></li></ol>
            <p class="western" ></p>
            <ol start="11">
            <li>
            <p ><strong>Bhuvan</strong></p>
            <p ><u><a href="https://bhuvan.nrsc.gov.in/"><strong>https://bhuvan.nrsc.gov.in/</strong></a></u></p></li></ol>
            <p class="western" ></p>
            <ol start="12">
            <li>
            <p ><strong>National Remote Sensing Centre</strong></p>
            <p ><u><a href="https://www.nrsc.gov.in/"><strong>https://www.nrsc.gov.in/</strong></a></u></p></li></ol>
            <p ></p></div>}
        />

    )
}
export default E_linksPage;